import type { CredentialEdition, CredentialEditionSlug } from './types';

// The Next tree ships three credential-view-26-*.tsx / credential-face-26-*.tsx twins.
// They differ only in the props below, so they are ONE view here and this is the content
// keyed by edition slug (PORTING.md G5). The 3D scene, the physics and the share dialog
// are identical across all three.
export const CREDENTIAL_EDITIONS: Record<CredentialEditionSlug, CredentialEdition> = {
  '26-ar': {
    face: {
      dateRange: '8 → 10 MAYO',
      cityLabel: 'BUENOS AIRES [ARG]',
      cityY: -0.34,
      logoGroupTexture: '/hack-26/credentials/logo-group.png',
      logo: { y: -0.5, width: 0.78, height: 0.141 },
      logoGroup: { y: -0.66, width: 0.76, height: 0.092 },
    },
    backgroundItems: [
      {
        src: '/hack-26/landing/cassete-x.webp',
        alt: '',
        className:
          '-right-[6%] top-[4%] w-[50vw] max-w-[420px] sm:right-[10%] sm:top-[8%] sm:w-[28vw]',
        width: 800,
        height: 500,
        fromTransform: 'translate(40px, -40px) rotate(-25deg)',
        toTransform: 'translate(0, 0) rotate(-12deg)',
        delay: 100,
      },
      {
        src: '/hack-26/landing/guitar-pick-x.webp',
        alt: '',
        className:
          'top-[26%] left-[6%] w-[22vw] max-w-[210px] sm:left-[40%] sm:top-[20%] sm:w-[14vw]',
        width: 200,
        height: 220,
        fromTransform: 'translate(-20px, -30px) rotate(40deg)',
        toTransform: 'translate(0, 0) rotate(15deg)',
        delay: 250,
        opacity: 0.4,
      },
      {
        src: '/hack-26/landing/mate-x.webp',
        alt: '',
        className:
          '-left-[8%] bottom-[2%] w-[55vw] max-w-[480px] sm:bottom-[6%] sm:left-[10%] sm:w-[32vw]',
        width: 800,
        height: 1100,
        fromTransform: 'translate(-40px, 40px) rotate(-20deg)',
        toTransform: 'translate(0, 0) rotate(-6deg)',
        delay: 50,
      },
      {
        src: '/hack-26/landing/banana-x.webp',
        alt: '',
        className:
          '-right-[8%] top-[48%] w-[52vw] max-w-[520px] sm:right-[10%] sm:top-auto sm:bottom-[10%] sm:w-[34vw]',
        width: 1000,
        height: 500,
        fromTransform: 'translate(40px, 40px) rotate(35deg)',
        toTransform: 'translate(0, 0) rotate(18deg)',
        delay: 180,
      },
    ],
    city: 'BUENOS AIRES',
    dateRange: '8 → 10 MAYO',
    share: {
      url: 'https://hack.platan.us/26-ar',
      city: 'Buenos Aires',
      dates: 'del 8 al 10 de mayo',
    },
  },

  '26-mx': {
    face: {
      dateRange: '19 → 21 JUNIO',
      cityLabel: 'CDMX [MEX]',
      cityY: -0.3,
      logoGroupTexture: '/hack-26-mx/credentials/logo-group.png',
      logo: { y: -0.43, width: 0.82, height: 0.1486 },
      logoGroup: { y: -0.64, width: 0.7, height: 0.192 },
    },
    backgroundItems: [
      {
        src: '/hack-26-mx/landing/sombrero-x.webp',
        alt: '',
        className:
          '-right-[6%] top-[4%] w-[52vw] max-w-[440px] sm:right-[8%] sm:top-[8%] sm:w-[30vw]',
        width: 640,
        height: 476,
        fromTransform: 'translate(40px, -40px) rotate(20deg)',
        toTransform: 'translate(0, 0) rotate(45deg)',
        delay: 100,
      },
      {
        src: '/hack-26-mx/landing/chili-x.webp',
        alt: '',
        className:
          'top-[18%] -left-[2%] w-[36vw] max-w-[320px] sm:left-[14%] sm:top-[12%] sm:w-[21vw]',
        width: 640,
        height: 575,
        fromTransform: 'translate(-20px, -30px) rotate(28deg) scaleX(-1)',
        toTransform: 'translate(0, 0) rotate(8deg) scaleX(-1)',
        delay: 250,
        opacity: 0.4,
      },
      {
        src: '/hack-26-mx/landing/calavera-x.webp',
        alt: '',
        className:
          '-left-[8%] bottom-[2%] w-[52vw] max-w-[440px] sm:bottom-[6%] sm:left-[9%] sm:w-[30vw]',
        width: 596,
        height: 640,
        fromTransform: 'translate(-40px, 40px) rotate(-20deg)',
        toTransform: 'translate(0, 0) rotate(-6deg)',
        delay: 50,
      },
      {
        src: '/hack-26-mx/landing/taco-x.webp',
        alt: '',
        className:
          '-right-[8%] top-[48%] w-[46vw] max-w-[440px] sm:right-[9%] sm:top-auto sm:bottom-[10%] sm:w-[28vw]',
        width: 640,
        height: 540,
        fromTransform: 'translate(40px, 40px) rotate(-20deg)',
        toTransform: 'translate(0, 0) rotate(-45deg)',
        delay: 180,
      },
    ],
    city: 'CIUDAD DE MÉXICO',
    dateRange: '19 → 21 JUNIO',
    share: {
      url: 'https://hack.platan.us/26-mx',
      city: 'Ciudad de México',
      dates: 'del 19 al 21 de junio',
    },
  },

  '26-co': {
    face: {
      dateRange: '21 → 23 AGOSTO',
      cityLabel: 'BOGOTÁ [COL]',
      cityY: -0.3,
      logoGroupTexture: '/hack-26-co/credentials/logo-group.png',
      logo: { y: -0.43, width: 0.82, height: 0.1486 },
      logoGroup: { y: -0.64, width: 0.7, height: 0.192 },
    },
    backgroundItems: [
      {
        src: '/hack-26-co/landing/chiva-x.webp',
        alt: '',
        className:
          '-right-[14%] top-[24%] w-[86vw] max-w-[680px] sm:-right-[6%] sm:top-[20%] sm:w-[52vw] sm:max-w-[900px]',
        width: 1000,
        height: 631,
        fromTransform: 'translate(70px, -60px) rotate(-26deg)',
        toTransform: 'translate(0, 0) rotate(-14deg)',
        delay: 100,
      },
      {
        src: '/hack-26-co/landing/sombrero-vueltiao-x.webp',
        alt: '',
        className:
          'top-[16%] -left-[6%] w-[42vw] max-w-[360px] sm:left-[10%] sm:top-[10%] sm:w-[24vw]',
        width: 560,
        height: 489,
        fromTransform: 'translate(-20px, -30px) rotate(28deg)',
        toTransform: 'translate(0, 0) rotate(10deg)',
        delay: 250,
        opacity: 0.4,
      },
      {
        src: '/hack-26-co/landing/acordeon-x.webp',
        alt: '',
        className:
          '-left-[8%] bottom-[3%] w-[46vw] max-w-[400px] sm:bottom-[7%] sm:left-[8%] sm:w-[26vw]',
        width: 560,
        height: 517,
        fromTransform: 'translate(-40px, 40px) rotate(-20deg)',
        toTransform: 'translate(0, 0) rotate(-6deg)',
        delay: 50,
      },
    ],
    city: 'BOGOTÁ',
    dateRange: '21 → 23 AGOSTO',
    share: {
      url: 'https://hack.platan.us/26-co',
      city: 'Bogotá',
      dates: 'del 21 al 23 de agosto',
    },
  },

  '26-ve': {
    face: {
      dateRange: '23 → 25 OCTUBRE',
      cityLabel: 'CARACAS [VEN]',
      cityY: -0.3,
      logoGroupTexture: '/hack-26-ve/credentials/logo-group.png',
      logo: { y: -0.43, width: 0.82, height: 0.1486 },
      logoGroup: { y: -0.64, width: 0.7, height: 0.192 },
    },
    backgroundItems: [
      {
        src: '/hack-26-ve/landing/loro-x.webp',
        alt: '',
        className:
          '-right-[10%] top-[14%] w-[62vw] max-w-[520px] sm:right-[2%] sm:top-[10%] sm:w-[26vw]',
        width: 1000,
        height: 1194,
        fromTransform: 'translate(70px, -60px) rotate(12deg)',
        toTransform: 'translate(0, 0) rotate(-4deg)',
        delay: 100,
      },
      {
        src: '/hack-26-ve/landing/maracas-x.webp',
        alt: '',
        className:
          'top-[20%] -left-[8%] w-[48vw] max-w-[400px] sm:left-[8%] sm:top-[12%] sm:w-[22vw]',
        width: 1000,
        height: 1047,
        fromTransform: 'translate(-20px, -30px) rotate(28deg)',
        toTransform: 'translate(0, 0) rotate(12deg)',
        delay: 250,
        opacity: 0.45,
      },
      {
        src: '/hack-26-ve/landing/orquidea-x.webp',
        alt: '',
        className:
          '-left-[6%] bottom-[3%] w-[50vw] max-w-[420px] sm:bottom-[6%] sm:left-[10%] sm:w-[24vw]',
        width: 1000,
        height: 1044,
        fromTransform: 'translate(-40px, 40px) rotate(-20deg)',
        toTransform: 'translate(0, 0) rotate(-8deg)',
        delay: 50,
      },
    ],
    city: 'CARACAS',
    dateRange: '23 → 25 OCTUBRE',
    share: {
      url: 'https://hack.platan.us/26-ve',
      city: 'Caracas',
      dates: 'del 23 al 25 de octubre',
    },
    exportArt: [
      { src: '/hack-26-ve/landing/loro-x.webp', x: 800, y: 330, width: 420, rotate: -6, opacity: 0.9 },
      { src: '/hack-26-ve/landing/maracas-x.webp', x: 170, y: 250, width: 300, rotate: 10, opacity: 0.6 },
      { src: '/hack-26-ve/landing/orquidea-x.webp', x: 190, y: 1090, width: 330, rotate: -8, opacity: 0.8 },
    ],
  },
};
